import React, {useState} from 'react';
import {ToastSeverityType} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {DashboardReportsApi} from "../../../api/DashboardReportsApi";
import {ConfirmDialog} from "primereact/confirmdialog";
import {useDeleteSingleReport} from "../../../api/api-hooks/apiHooks";

type GenerateReportHistoryType = {
    dashboardId: number
    data: Array<{file:string}>
    showToast(severity: ToastSeverityType, summary: string, detail: string, lifetime?: number): void
    genId:number;

    closeDialog():void
}

const GeneratedReportHistoryList = (props: GenerateReportHistoryType) => {

    const {mutate: deleteReportGeneration} = useDeleteSingleReport({
        onSuccess: () => {
            props.showToast("success", "", "Report deleted")
        },
        onMutate: () => {
            props.showToast("success", "", "Deleting report")
        },
        onFailure: () => {
            props.showToast("error", "", "Failed to delete report")
        }
    });

    const downloadReportBody = (rowData: {file:string}) => {
        return (
            <div className={"flex align-items-center"}>
                    <Button icon={"pi pi-download"} className="p-button-rounded p-button-text p-button-sm"
                            onClick={() => {
                                window.open(DashboardReportsApi.getDownloadUrl(props.genId, rowData.file))
                            }}
                    />
            </div>
        ) || null;
    }

    const deleteGenerationBody = (rowData: {file:string}) => {
        const [removeDialog, setRemoveDialog] = useState(false)

        const accept = () => {
            deleteReportGeneration({reportId:rowData.file, genId: props.genId})
            if(props.data.length<=1) {
                props.closeDialog()
            }
        }

        return <>
            <ConfirmDialog visible={removeDialog}
                           onHide={() => setRemoveDialog(false)}
                           message="Do you want to remove this report?"
                           header="Delete Confirmation"
                           icon="pi pi-info-circle"
                           acceptClassName={'p-button-danger'}
                           accept={accept}/>
            <div className={"flex align-items-center"}>
                    <Button icon={"pi pi-trash"} style={{color: "red"}}
                            id={"history-button"}
                            className="p-button-rounded p-button-text p-button-sm"
                            onClick={() => {
                                setRemoveDialog(true)
                            }}
                    />
            </div>
        </>
    }

    return <>
        <DataTable value={props.data} size="small" paginator responsiveLayout="scroll"
                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                   currentPageReportTemplate="Showing {first} - {last} / {totalRecords}"
                   rows={10}>
            <Column field={"file"} header={"File"}/>
            <Column body={downloadReportBody} style={{width: "0"}}/>
            <Column body={deleteGenerationBody} style={{width: "0"}}/>
        </DataTable>
        </>;
};

export default GeneratedReportHistoryList;